// extracted by mini-css-extract-plugin
export default {"Subreddit":"subreddit_Subreddit__5J+v2","post":"subreddit_post__zsajc","skeleton":"subreddit_skeleton__xwf25"};